// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"66ad17f5","335":"d57fa42a","692":"384b2cec","718":"89d136f2"}[chunkId] + ".chunk.js";
};